// erp.js – pure JavaScript, no HTML / CSS
// ===========================================================
// 0. Canvas “willReadFrequently” polyfill
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {
    shop: "fishion-llc.myshopify.com",
    currency: { active: "AED" }
  };
}
window.__st = window.__st || { cid: undefined };
(() => {
  const original = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function (type, att) {
    if (type === '2d') {
      att = att || {};
      att.willReadFrequently = true;
    }
    return original.call(this, type, att);
  };
})();

// 1. CONFIG
const SYSTEM = {
  BRIDGE: "https://script.google.com/macros/s/AKfycbyv5kSzfW8ZLzUHOsmI2HItnXAYM_UH2KWLihGL859kxunQYyzMy-yEDV-I1tZP1g/exec",
  AUTH:   "OceanMania_Secure_998877"
};
const NO_IMAGE = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' style='background:%23ccc'%3E%3Ctext x='50%25' y='50%25' dy='.3em' text-anchor='middle' font-family='Arial' font-size='10'%3EWG%3C/text%3E%3C/svg%3E";
const SHOP_CURRENCY = window.SHOP_CURRENCY || "AED";
const formatPrice   = a => `${SHOP_CURRENCY} ${parseFloat(a).toFixed(2)}`;
const PAGE_SIZE     = 10;
const USER_ROLE     = window.USER_ROLE || "Admin";

let MASTER_DB = { products:[], orders:[], customers:[], collections:[], mapping:[], location:null };
let UI_DATA   = { inventory:[], orders:[], customers:[] };
let CURRENT_PAGE = { inventory:1, orders:1, customers:1 };

let scannerActive = false;
let scanTimeout = null;

// 2. PAGINATION
const paginate = (items, page, module) => {
  if (!items || !items.length) return [];
  const start = (page - 1) * PAGE_SIZE;
  const slice = items.slice(start, start + PAGE_SIZE);
  renderPaginationUI(module, items.length, page);
  return slice;
};
window.renderPaginationUI = (mod, total, cur) => {
  const holder = document.getElementById(`${mod}-pagination-holder`);
  if (!holder) return;
  const pages = Math.ceil(total / PAGE_SIZE) || 1;
  holder.innerHTML = `
    <div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:15px">
      <button onclick="changeModulePage('${mod}',${cur - 1})"
              ${cur<=1?'disabled style="opacity:.5"':''} class="btn-export">Prev</button>
      <span style="font-weight:bold">Page ${cur} of ${pages}</span>
      <button onclick="changeModulePage('${mod}',${cur + 1})"
              ${cur>=pages?'disabled style="opacity:.5"':''} class="btn-export">Next</button>
    </div>`;
};
window.changeModulePage = (mod, p) => {
  CURRENT_PAGE[mod] = p;
  if (mod === 'inventory') renderInventoryUI();
  if (mod === 'orders')    renderOrdersUI();
  if (mod === 'customers') renderCustomersUI();
};

// 3. API BRIDGE
async function queryShopify(endpoint, method='GET', payload=null, fetch_all=false){
  try{
    const res = await fetch(SYSTEM.BRIDGE,{
      method:'POST',
      mode:'cors',
      headers:{'Content-Type':'text/plain'},
      body:JSON.stringify({auth_key:SYSTEM.AUTH, endpoint, method, data:payload, fetch_all})
    });
    return await res.json();
  }catch(e){
    console.error('API Error ('+endpoint+'):',e); return {};
  }
}
function runLiveClock() {
    setInterval(() => {
        // Digital Clock (Agar koi element 'att-timer' ID ke sath ho)
        const timerEl = document.getElementById('att-timer');
        if(timerEl) timerEl.innerText = new Date().toLocaleTimeString();

        // Dashboard Card: Day & Date update
        const dayEl = document.getElementById('current-day-display');
        const dateEl = document.getElementById('current-date-display');
        
        if (dayEl || dateEl) {
            const now = new Date();
            if(dayEl) dayEl.innerText = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(now);
            if(dateEl) dateEl.innerText = now.toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
        }
    }, 1000);
}
async function bootSystem(){
  console.log('ERP Booting...'); window.toggleLoader(true);
  try {
    // fetch_all:true lazmi hai taaki 250 se zyada items load hon
    const [resP, resO, resC, resL, resCl, resMap] = await Promise.all([
      queryShopify('/products.json','GET',null,true),
      queryShopify('/orders.json','GET',null,true),
      queryShopify('/customers.json','GET',null,true),
      queryShopify('/locations.json','GET',null,true),
      queryShopify('/custom_collections.json','GET',null,true),
      queryShopify('/collects.json','GET',null,true)
    ]);

    MASTER_DB.products    = resP.products || [];
    MASTER_DB.orders      = resO.orders || [];
    MASTER_DB.customers   = resC.customers || [];
    MASTER_DB.collections = resCl.custom_collections || [];
    MASTER_DB.mapping     = resMap.collects || [];
    MASTER_DB.location    = resL.locations?.[0]?.id || null;

    UI_DATA.inventory  = [...MASTER_DB.products];
    UI_DATA.orders     = [...MASTER_DB.orders];
    UI_DATA.customers  = [...MASTER_DB.customers];

    updateStats(); 
    // syncOrderStats();
    setupFilterDropdowns();
    
    // Refresh all UIs
    renderInventoryUI(); 
    renderOrdersUI(); 
    renderCustomersUI();

    console.log(`Loaded: ${MASTER_DB.orders.length} Orders, ${MASTER_DB.customers.length} Customers`);
  } catch(err) {
    console.error('Boot Error:', err);
  } finally {
    window.toggleLoader(false);
  }
}
// 5. INVENTORY
function renderInventoryUI(){
  const target = document.getElementById('inventory-target'); if(!target) return;
  window.toggleLoader(true);
  
  // Naya fallback image define kiya (Offline safe)
  const NO_IMAGE = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' style='background:%23e2e8f0'%3E%3Ctext x='50%25' y='50%25' dy='.3em' text-anchor='middle' font-family='sans-serif' font-size='10' fill='%2364748b'%3ENo Img%3C/text%3E%3C/svg%3E";

  const all = UI_DATA.inventory || [];
  const start = (CURRENT_PAGE.inventory-1)*PAGE_SIZE;
  const pageItems = all.slice(start,start+PAGE_SIZE);
  
  if(!all.length){
    target.innerHTML = `
      <div class="empty-state-container">
        <div style="font-size:50px;margin-bottom:15px;opacity:.6">📦</div>
        <h3 style="margin:0;color:#1e293b">No Products Found</h3>
        <button onclick="resetInventoryFilters()" class="btn-export">Reset Filters</button>
      </div>`;
    window.toggleLoader(false); return;
  }
  const html = pageItems.map(p=>`
    <div class="product-group-card" id="card-${p.id}">
      <div class="card-header" onclick="toggleProductTree('${p.id}')">
        <div class="product-info">
          <img src="${p.image?.src || NO_IMAGE}" class="product-thumb" onerror="this.onerror=null;this.src='${NO_IMAGE}'">
          <div>
            <h3 class="product-title">${p.title}</h3>
            <small class="product-meta">${p.variants.length} Variants | ${p.vendor}</small>
          </div>
        </div>
        <div id="icon-${p.id}" class="toggle-icon">+</div>
      </div>
      <div id="tree-${p.id}" class="card-content" style="display:none">
        <table class="enterprise-table">
          <thead>
            <tr><th>Variant</th><th>SKU</th><th>Price (${SHOP_CURRENCY})</th><th>Stock</th><th class="text-right">Action</th></tr>
          </thead>
          <tbody>
            ${p.variants.map(v=>`
              <tr>
                <td class="font-medium">${v.title}</td>
                <td class="text-muted">${v.sku||'N/A'}</td>
                <td class="price-text">${formatPrice(v.price)}</td>             
<td class="stock-count" style="color:${v.inventory_quantity <= 0 ? '#ef4444' : (v.inventory_quantity <= 5 ? '#f59e0b' : 'inherit')}; font-weight:bold">
    ${v.inventory_quantity}
</td>
                <td class="text-right">
                  <div class="update-actions">
                    <input type="number" id="in-${v.id}" class="qty-input" placeholder="0">
                    <button onclick="syncStock('${v.id}','${v.inventory_item_id}', event)" class="btn-set">Set</button>
                  </div>
                </td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
    </div>`).join('');
  target.innerHTML = `<div class="inventory-container">${html}</div><div id="inventory-pagination-holder"></div>`;
  renderPaginationUI('inventory',all.length,CURRENT_PAGE.inventory);
  window.toggleLoader(false);
}
// 5. Mark Attendance Function (Consolidated)
window.markAttendance = async () => {
    const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText;
    
    if (!userName || userName === "Staff") {
        alert("Error: User name not found. Please refresh the page.");
        return;
    }

    // Check if geolocation is available
    if (!navigator.geolocation) {
        alert("Geolocation is not supported by your browser.");
        return;
    }

    if (window.toggleLoader) window.toggleLoader(true);

    navigator.geolocation.getCurrentPosition(
        async (pos) => {
            const { latitude, longitude } = pos.coords;
            
            try {
                const res = await fetch(SYSTEM.BRIDGE, {
                    method: 'POST',
                    mode: 'cors',
                    headers: { 'Content-Type': 'text/plain' },
                    body: JSON.stringify({
                        auth_key: SYSTEM.AUTH,
                        endpoint: '/attendance_log',
                        method: 'POST',
                        data: { 
                            name: userName, 
                            lat: latitude, 
                            lng: longitude,
                            timestamp: new Date().toISOString(),
                            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                        }
                    })
                });

                const result = await res.json();
                
                // Show success/error message
                showAttendanceNotification(result.status === "success", result.message);
                
                // Refresh history after successful punch
                if (result.status === "success") {
                    await fetchAttendanceHistory();
                }

            } catch (e) {
                console.error("Attendance Error:", e);
                showAttendanceNotification(false, "Server connection failed. Please try again.");
            } finally {
                if (window.toggleLoader) window.toggleLoader(false);
            }
        },
        (err) => {
            if (window.toggleLoader) window.toggleLoader(false);
            let errorMsg = "Location access denied.";
            if (err.code === 1) errorMsg = "Please enable location permissions to mark attendance.";
            else if (err.code === 2) errorMsg = "Location unavailable. Please try again.";
            else if (err.code === 3) errorMsg = "Location request timed out.";
            
            alert(errorMsg);
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
};
function showAttendanceNotification(isSuccess, message) {
    // Create or update notification element
    let notif = document.getElementById('attendance-notification');
    if (!notif) {
        notif = document.createElement('div');
        notif.id = 'attendance-notification';
        notif.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            padding: 15px 25px;
            border-radius: 8px;
            color: white;
            font-weight: 600;
            z-index: 10000;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        `;
        document.body.appendChild(notif);
    }

    notif.style.background = isSuccess ? '#10b981' : '#ef4444';
    notif.innerHTML = `${isSuccess ? '✅' : '❌'} ${message}`;
    notif.style.opacity = '1';
    notif.style.transform = 'translateY(0)';

    setTimeout(() => {
        notif.style.opacity = '0';
        notif.style.transform = 'translateY(-20px)';
    }, 4000);
}
function updateLiveDateTime() {
    const now = new Date();
    
    // 1. Din nikalne ke liye (e.g., Friday)
    const dayOptions = { weekday: 'long' };
    const dayName = new Intl.DateTimeFormat('en-US', dayOptions).format(now);
    
    // 2. Tareekh format karne ke liye (DD/MM/YYYY)
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months 0-11 hote hain
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // HTML mein data insert karna
    const dayElement = document.getElementById('current-day-display');
    const dateElement = document.getElementById('current-date-display');

    if (dayElement) dayElement.innerText = dayName;
    if (dateElement) dateElement.innerText = formattedDate;
}
// 10. Initialization (Call this once when attendance pane opens)
window.initAttendanceSystem = function() {
    console.log("Initializing Attendance System...");
    
    // Start clock
    const clockInterval = startAttendanceClock();
    
    // Load history
    fetchAttendanceHistory();
    
    // Return cleanup function if needed
    return () => clearInterval(clockInterval);
};
// 2. Page load par sirf ek function call karein
document.addEventListener('DOMContentLoaded', initAttendanceSystem);
async function loadDashboardStats() {
    try {
        const res = await fetch(SYSTEM.BRIDGE, { /* your fetch config */ });
        const stats = await res.json();
        
        // Pehle check karein ke element exist karta hai ya nahi
        const varElem = document.getElementById('count-variants');
        const outElem = document.getElementById('count-out-stock');
        const prodElem = document.getElementById('count-products');

        if (prodElem) prodElem.innerText = stats.total_products;
        if (varElem) varElem.innerText = stats.total_variants;
        if (outElem) outElem.innerText = stats.out_of_stock;

    } catch (e) {
        console.error("Stats Sync Error", e);
    }
}

// async function syncOrderStats() {
//     try {
//         const elPaid = document.getElementById('stat-orders-paid');
//         if (!elPaid) return;

//         const res = await fetch(SYSTEM.BRIDGE, {
//             method: 'POST',
//             body: JSON.stringify({
//                 auth_key: SYSTEM.AUTH,
//                 endpoint: '/dashboard_stats' 
//             })
//         });
        
//         const stats = await res.json();
        
//         // --- 24 Hours Filter Logic ---
//         const now = new Date();
//         const twentyFourHoursAgo = new Date(now.getTime() - (24 * 60 * 60 * 1000));

//         // Agar server se order list aa rahi hai, toh filter karein
//         // Warna agar server direct count bhej raha hai, toh ye backend se hoga
//         if (Array.isArray(stats.recent_orders)) {
//             const recentPaid = stats.recent_orders.filter(order => {
//                 const orderDate = new Date(order.created_at);
//                 return orderDate >= twentyFourHoursAgo && order.financial_status === 'paid';
//             });
//             elPaid.innerText = recentPaid.length;
//         } else {
//             // Agar backend sirf number bhej raha hai, toh filhal wahi display hoga
//             elPaid.innerText = stats.paid_last_24h || stats.paid || 0;
//         }

//         console.log("Last 24h Paid Orders Updated");

//     } catch (e) {
//         console.error("Order Sync Failed:", e);
//     }
// }

async function refreshAllData() {
    console.log("ERP Booting...");
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                auth_key: AUTH_KEY,
                endpoint: '/dashboard_stats'
            })
        });
        const stats = await response.json();

        if (stats.unfulfilled !== undefined) {
            // Stats Update Karein
            document.getElementById('unfulfilled-count').innerText = stats.unfulfilled;
            document.getElementById('paid-count').innerText = stats.paid;
            
            // Attendance History Load Karein
            renderAttendanceHistory(); 
            
            console.log("Loaded Successfully:", stats);
        } else {
            console.error("Data structure mismatch:", stats);
        }
    } catch (err) {
        console.error("Connection Error:", err);
        alert("Server se connection nahi ho raha. Deployment URL check karein.");
    }
}
window.toggleProductTree = id=>{
  const content=document.getElementById(`tree-${id}`);
  const icon=document.getElementById(`icon-${id}`);
  const card=document.getElementById(`card-${id}`);
  const open = content.style.display!=='none';
  content.style.display=open?'none':'block';
  icon.innerText=open?'+':'−';
  card.style.borderColor=open?'#e5e7eb':'#10b981';
};
window.applyFilters = window.filterInventory;
window.switchModule = function(moduleName, navId) {
    const adminOnlyModules = ['orders', 'customers'];
    if (USER_ROLE !== 'Admin' && adminOnlyModules.includes(moduleName)) {
        // Staff ko orders ya customers pane par white screen ya error message dikhayein
        document.getElementById(moduleName + '-target').innerHTML = 
            `<div class="empty-state-container"><h3>🚫 Restricted Access</h3><p>Admins only.</p></div>`;
        alert("🚫 Access Denied");
        return;
    }

    // UI Toggle
    document.querySelectorAll('.main-pane').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
    
    document.getElementById(moduleName + '-pane').classList.add('active');
    document.getElementById(navId).classList.add('active');
    
    // 🔥 Update Header & Export Button Context
    const displayTitle = moduleName.toUpperCase();
    document.getElementById('panel-title').innerText = displayTitle;

    // Export buttons ko batana ke ab konsa module export karna hai
    const exportBtns = document.querySelectorAll('.btn-export');
    exportBtns.forEach(btn => {
        if(btn.classList.contains('excel')) {
            btn.setAttribute('onclick', `exportToExcel('${displayTitle}')`);
        } else if(btn.classList.contains('pdf')) {
            btn.setAttribute('onclick', `exportToPDF('${displayTitle}')`);
        }
    });

    // 🔥 Module-specific initialization
    if (moduleName === 'orders') renderOrdersUI();
    if (moduleName === 'customers') renderCustomersUI();
    if (moduleName === 'inventory') renderInventoryUI();
    
    // 🔥 Attendance module initialization with clock and history
    if (moduleName === 'attendance') {
        // Start clock and fetch history
        if (typeof window.initAttendanceSystem === 'function') {
            window.initAttendanceSystem();
        } else {
            // Fallback if initAttendanceSystem not loaded yet
            console.warn('initAttendanceSystem not found, using fallback');
            startAttendanceClock();
            fetchAttendanceHistory();
        }
        
        // Toggle export buttons for attendance
        const attBtn = document.getElementById('att-export-btn');
        const invBtn = document.getElementById('inv-export-btn');
        const pdfBtn = document.getElementById('pdf-export-btn');
        
        if (attBtn) attBtn.style.display = 'inline-block';
        if (invBtn) invBtn.style.display = 'none';
        if (pdfBtn) pdfBtn.style.display = 'none';
    } else {
        // Reset export buttons for other modules
        const attBtn = document.getElementById('att-export-btn');
        const invBtn = document.getElementById('inv-export-btn');
        const pdfBtn = document.getElementById('pdf-export-btn');
        
        if (attBtn) attBtn.style.display = 'none';
        if (invBtn) invBtn.style.display = 'inline-block';
        if (pdfBtn) pdfBtn.style.display = 'inline-block';
    }
};
// Function definition mein 'event' add karein
window.syncStock = async (vId, itemId, event) => { 
  const input = document.getElementById(`in-${vId}`);
  const newVal = parseInt(input.value);
  
  if (isNaN(newVal)) return alert('Please enter a valid number');
  
  // 'event' ab valid reference hoga
  const btn = event.target; 
  const origText = btn.innerText;
  btn.innerText = 'Saving...';
  btn.disabled = true;

  try {
    const res = await queryShopify('/inventory_levels/set.json', 'POST', {
      location_id: MASTER_DB.location,
      inventory_item_id: itemId,
      available: newVal
    });

    // Check karein ke response mein error to nahi
    if (res && res.inventory_level) {
      MASTER_DB.products.forEach(p => {
        const variant = p.variants.find(v => v.id == vId);
        if (variant) variant.inventory_quantity = newVal;
      });

      UI_DATA.inventory = [...MASTER_DB.products];
      renderInventoryUI();
      updateStats();
      alert("✅ Stock Updated!");
    } else {
      throw new Error(res.error || 'Shopify update failed');
    }
  } catch (err) {
    console.error("Sync Error:", err);
    alert('❌ Update failed: ' + err.message);
  } finally {
    btn.innerText = origText;
    btn.disabled = false;
  }
};
async function updateDashboardStats() {
    try {
        const response = await fetch(SYSTEM.BRIDGE, {
            method: 'POST',
            body: JSON.stringify({
                auth_key: SYSTEM.AUTH,
                endpoint: '/dashboard_stats' // Backend function jo humne pehle banayi
            })
        });
        const stats = await response.json();

        // IDs ko variable mein save karein
        const elProd = document.getElementById('stat-products');
        const elVar = document.getElementById('stat-variants');
        const elOut = document.getElementById('stat-stock-out');
        const elTotalStock = document.getElementById('stat-stock-total');

        // Check karein ke element null to nahi (Error Fix)
        if (elProd) elProd.innerText = stats.total_products || 0;
        if (elVar) elVar.innerText = stats.total_variants || 0;
        if (elOut) elOut.innerText = stats.out_of_stock || 0;
        
        // Orders ka data update karein (agar backend se aa raha ho)
        const elUnful = document.getElementById('stat-orders-unful');
        if (elUnful && stats.unfulfilled) elUnful.innerText = stats.unfulfilled;

    } catch (err) {
        console.error("Dashboard Sync Error:", err);
    }
}
// 6. ORDERS
function renderOrdersUI(){
  const target=document.getElementById('orders-target'); if(!target)return;
  const all=UI_DATA.orders||[];
  const start=(CURRENT_PAGE.orders-1)*PAGE_SIZE;
  const pageOrders=all.slice(start,start+PAGE_SIZE);
  target.innerHTML=`
    <div class="product-card">
      <div id="orders-table-container">
        <table class="enterprise-table">
          <thead><tr><th>Order</th><th>Customer</th><th>Phone</th><th>Total (${SHOP_CURRENCY})</th></tr></thead>
          <tbody>
            ${pageOrders.map(o=>`
              <tr>
                <td><b>${o.name}</b></td>
                <td>${o.customer?.first_name||'Guest'}</td>
                <td>${o.customer?.phone||'N/A'}</td>
                <td><b>${formatPrice(o.total_price)}</b></td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
      <div id="orders-pagination-holder"></div>
    </div>`;
  renderPaginationUI('orders',all.length,CURRENT_PAGE.orders);
}

// 7. CUSTOMERS
function renderCustomersUI(){
  const target=document.getElementById('customers-target'); if(!target)return;
  window.toggleLoader(true);
  const all=UI_DATA.customers||[];
  if(!all.length){target.innerHTML='<div style="padding:40px;text-align:center">No Customers Found</div>'; window.toggleLoader(false);return}
  const start=(CURRENT_PAGE.customers-1)*PAGE_SIZE;
  const pageCust=all.slice(start,start+PAGE_SIZE);
  target.innerHTML=`
    <div class="product-card">
      <table class="enterprise-table">
        <thead><tr><th>Name</th><th>Phone</th><th>Email</th><th>Total Spent</th></tr></thead>
        <tbody>
          ${pageCust.map(c=>{
            const phone=c.phone||(c.default_address?c.default_address.phone:'N/A');
            return`
              <tr>
                <td><b>${c.first_name||''} ${c.last_name||''}</b></td>
                <td>${phone}</td>
                <td>${c.email||'N/A'}</td>
                <td><b>${formatPrice(c.total_spent||0)}</b></td>
              </tr>`;
          }).join('')}
        </tbody>
      </table>
      <div id="customers-pagination-holder"></div>
    </div>`;
  setTimeout(()=>renderPaginationUI('customers',all.length,CURRENT_PAGE.customers),100);
  window.toggleLoader(false);
}

// 8. FILTER / RESET
window.filterInventory=()=>{
  const q = document.getElementById('inv-search')?.value.trim().toLowerCase() || '';
  const collId=document.getElementById('inv-coll')?.value||'';
  const vendor=document.getElementById('inv-vendor')?.value||'';
  const stockLimit=document.getElementById('inv-status')?.value||'all';
  let mappedIds=collId?MASTER_DB.mapping.filter(m=>m.collection_id==collId).map(m=>m.product_id):null;
  UI_DATA.inventory=MASTER_DB.products.filter(p=>{
    const totalStock=p.variants.reduce((a,v)=>a+(v.inventory_quantity||0),0);
    const matchQ=p.title.toLowerCase().includes(q)||p.variants.some(v=>v.sku?.toLowerCase().includes(q));
    const matchC=!mappedIds||mappedIds.includes(p.id);
    const matchV=!vendor||p.vendor===vendor;
    let matchStock=true;
    if(stockLimit==='low')matchStock=(totalStock<=5&&totalStock>0);
    else if(stockLimit==='out')matchStock=(totalStock<=0);
    else if(stockLimit==='in')matchStock=(totalStock>0);
    return matchQ&&matchC&&matchV&&matchStock;
  });
  CURRENT_PAGE.inventory=1; renderInventoryUI();
};
window.resetInventoryFilters=()=>{
  ['inv-search','inv-coll','inv-vendor','inv-status'].forEach(id=>{
    const el=document.getElementById(id);
    if(el)el.tagName==='SELECT'?el.selectedIndex=0:el.value='';
  });
  filterInventory();
};

function updateStats() {
    const safeSet = (id, value) => {
        const el = document.getElementById(id);
        if (el) el.innerText = value;
    };

    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - (48 * 60 * 60 * 1000));

    // --- Inventory ---
    const totalProds = MASTER_DB.products.length;
    let totalVars = 0, totalStock = 0, lowStockCount = 0, outOfStockCount = 0;
    MASTER_DB.products.forEach(p => {
        totalVars += p.variants.length;
        p.variants.forEach(v => {
            const qty = parseInt(v.inventory_quantity) || 0;
            totalStock += qty;
            if (qty <= 0) outOfStockCount++;
            else if (qty <= 5) lowStockCount++;
        });
    });

    // --- Orders Logic (Strict Fix) ---
    const allO = MASTER_DB.orders || [];

    // Filter out: Cancelled, Refunded, and Archived
    const activeOrders = allO.filter(o => {
        const isCancelled = o.cancelled_at !== null;
        const isRefunded = o.financial_status === 'refunded';
        // Kuch orders Archived hote hain unhe bhi nikal dete hain
        const isArchived = o.closed_at !== null && o.fulfillment_status === 'fulfilled';
        return !isCancelled && !isRefunded && !isArchived;
    });

    // 1. Paid & Fulfilled (24h)
    const paidFulfilled24h = activeOrders.filter(o => {
        const orderDate = new Date(o.created_at);
        return o.financial_status === 'paid' && 
               o.fulfillment_status === 'fulfilled' && 
               orderDate >= twentyFourHoursAgo;
    }).length;

    // 2. COD Orders & Fulfilled (24h)
    const codFulfilled24h = activeOrders.filter(o => {
        const orderDate = new Date(o.created_at);
        const isCOD = (o.financial_status === 'pending' || o.financial_status === 'authorized');
        return isCOD && 
               o.fulfillment_status === 'fulfilled' && 
               orderDate >= twentyFourHoursAgo;
    }).length;

    // 3. Total Unfulfilled (Ab bilkul accurate hoga)
    const totalUnfulfilled = activeOrders.filter(o => {
        // Sirf wahi jo "null" hain (bilkul ship nahi huye)
        return o.fulfillment_status === null || o.fulfillment_status === 'restocked';
    }).length;

    // --- UI Updates ---
    safeSet('stat-products', totalProds);
    safeSet('stat-variants', totalVars);
    safeSet('stat-stock-total', totalStock);
    safeSet('stat-stock-low', lowStockCount);
    safeSet('stat-stock-out', outOfStockCount);
    
    safeSet('stat-orders-paid', paidFulfilled24h);
    safeSet('stat-orders-cod', codFulfilled24h);
    safeSet('stat-orders-unful', totalUnfulfilled);

    console.clear();
}

function setupFilterDropdowns(){
  const coll=document.getElementById('inv-coll');
  const vend=document.getElementById('inv-vendor');

  if(coll) {
    coll.innerHTML='<option value="">All Collections</option>'+
      MASTER_DB.collections.map(c=>`<option value="${c.id}">${c.title}</option>`).join('');
  }

  if(vend){
    // .filter(v => v) se khaali (null/empty) vendors nikal jayenge
    // .sort() se list A-Z ho jayegi
    const unique = [...new Set(MASTER_DB.products.map(p => p.vendor))].filter(v => v).sort();
    
    vend.innerHTML = '<option value="">All Vendors</option>' + 
      unique.map(v => `<option value="${v}">${v}</option>`).join('');
  }
}

// 10. EXPORT
window.exportToPDF=modType=>{
  const{jsPDF}=window.jspdf; const doc=new jsPDF('l','mm','a4');
  const data=UI_DATA[modType.toLowerCase()]||[];
  const brand=(window.Shopify?window.Shopify.shop:'Store').split('.')[0].replace(/-/g,' ').toUpperCase();
  doc.setFontSize(20); doc.setTextColor(37,99,235);
  doc.text(`${brand} - ${modType} Report`,14,20);
  doc.setFontSize(10); doc.setTextColor(100);
  doc.text(`Generated on: ${new Date().toLocaleString()}`,14,28);
  let head=[],body=[],foot=[];
  if(modType.toLowerCase()==='inventory'){
    head=[["Product","Vendor","SKU",`Price (${SHOP_CURRENCY})`,"Stock"]];
    let sum=0;
    body=data.flatMap(p=>p.variants.map(v=>{sum+=(v.inventory_quantity||0);return[p.title,p.vendor,v.sku||'N/A',v.price,v.inventory_quantity]}));
    foot=[['','','','TOTAL UNITS:',sum]];
  }else if(modType.toLowerCase()==='orders'){
    head=[["Order","Customer","Phone","Status",`Amount (${SHOP_CURRENCY})`]];
    let sum=0;
    body=data.map(o=>{sum+=parseFloat(o.total_price||0);return[o.name,o.customer?.first_name||'Guest',o.customer?.phone||'N/A',o.financial_status,o.total_price]});
    foot=[['','','','TOTAL SALES:',sum.toFixed(2)]];
  }else if(modType.toLowerCase()==='customers'){
    head=[["Customer Name","Email","Phone",`Total Spent (${SHOP_CURRENCY})`]];
    let sum=0;
    body=data.map(c=>{sum+=parseFloat(c.total_spent||0);const p=c.phone||(c.default_address?c.default_address.phone:'N/A');return[`${c.first_name} ${c.last_name}`,c.email,p,c.total_spent]});
    foot=[['','','GRAND TOTAL:',sum.toFixed(2)]];
  }
  doc.autoTable({startY:35,head,body,foot,theme:'striped',headStyles:{fillColor:[37,99,235]},footStyles:{fillColor:[241,245,249],textColor:0,fontStyle:'bold'}});
  doc.save(`${brand}_${modType}_${Date.now()}.pdf`);
};
// 11. ATTENDANCE MODULE LOGIC
window.handleAttendanceSubmit = async (empId) => {
    if (!empId) return alert("Please enter or scan an Employee ID");

    const statusBox = document.getElementById('att-status-msg');
    statusBox.style.display = 'block';
    statusBox.innerHTML = "Processing...";
    statusBox.className = "status-box processing";

    try {
        // Hum wahi BRIDGE URL use karenge jo pehle se CONFIG mein hai
        const response = await fetch(SYSTEM.BRIDGE, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
                auth_key: SYSTEM.AUTH,
                endpoint: '/attendance_log', // Yeh endpoint Apps Script mein handle hoga
                method: 'POST',
                data: {
                    employee_id: empId,
                    timestamp: new Date().toLocaleString(),
                    shop: window.Shopify?.shop || "Fishon-AE"
                }
            })
        });

        const result = await response.json();

        if (result.status === "success") {
            statusBox.innerHTML = `✅ ${result.message}`;
            statusBox.className = "status-box success";
            if (navigator.vibrate) navigator.vibrate([100, 50, 100]);
            loadRecentLogs(); // Activity refresh karne ke liye
        } else {
            throw new Error(result.message || "Failed to log attendance");
        }
    } catch (err) {
        statusBox.innerHTML = `❌ Error: ${err.message}`;
        statusBox.className = "status-box error";
    }
    
    // 5 second baad message gayab kardein
    setTimeout(() => { statusBox.style.display = 'none'; }, 5000);
};
async function fetchAttendanceHistory() {
    const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText || "Staff";
    const target = document.getElementById('attendance-history-list');
    const presentStat = document.getElementById('stat-attendance-present');
    const absentStat = document.getElementById('stat-attendance-absent');
    
    if (!target) {
        console.warn("Attendance history target element not found");
        return;
    }

    // Show loading state
    target.innerHTML = "<div style='text-align:center;padding:20px;opacity:0.5;'>⏳ Loading history...</div>";

    try {
        const res = await fetch(SYSTEM.BRIDGE, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
                auth_key: SYSTEM.AUTH,
                endpoint: '/get_history', 
                data: { name: userName }
            })
        });

        // Check if response is OK
        if (!res.ok) {
            throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }

        const responseData = await res.json();
        
        // CRITICAL FIX: Ensure history is always an array
        let history = [];
        
        if (Array.isArray(responseData)) {
            history = responseData;
        } else if (responseData && Array.isArray(responseData.data)) {
            history = responseData.data;
        } else if (responseData && Array.isArray(responseData.history)) {
            history = responseData.history;
        } else if (responseData && typeof responseData === 'object') {
            // If it's an object with numeric keys, convert to array
            history = Object.values(responseData);
        }
        
        console.log("Processed history:", history); // Debug log

        // Update Dashboard Stats safely
        updateAttendanceStats(history, presentStat, absentStat);
        
        // Render UI
        renderAttendanceHistory(history, target);

    } catch (e) {
        console.error("History Load Error:", e);
        target.innerHTML = `
            <div style="text-align:center;padding:20px;color:#ef4444;">
                <div style="font-size:24px;margin-bottom:10px;">⚠️</div>
                <div>Sync Error: ${e.message}</div>
                <button onclick="fetchAttendanceHistory()" style="margin-top:10px;padding:5px 15px;">Retry</button>
            </div>`;
    }
}
// 4. Helper Functions
function getStatusClass(status) {
    if (!status) return 'background:#e5e7eb;color:#374151;';
    if (status.includes('Present')) return 'background:#dcfce7;color:#166534;';
    if (status.includes('Late')) return 'background:#fef3c7;color:#92400e;';
    if (status.includes('Absent')) return 'background:#fee2e2;color:#991b1b;';
    if (status.includes('Leave')) return 'background:#dbeafe;color:#1e40af;';
    return 'background:#e5e7eb;color:#374151;';
}

function getStatusIcon(status) {
    if (!status) return '⏱️';
    if (status.includes('Present')) return '✅';
    if (status.includes('Late')) return '🕒';
    if (status.includes('Absent')) return '❌';
    if (status.includes('Leave')) return '🏖️';
    return '⏱️';
}
function renderAttendanceHistory(history, target) {
    if (!Array.isArray(history) || history.length === 0) {
        target.innerHTML = `
            <div style="text-align:center;padding:30px;opacity:0.6;">
                <div style="font-size:40px;margin-bottom:10px;">📋</div>
                <div>No attendance records found.</div>
                <small style="display:block;margin-top:10px;">Be the first to punch in today!</small>
            </div>`;
        return;
    }

    // Sort by date descending (newest first)
    const sortedHistory = [...history].sort((a, b) => {
        if (!a.date || !b.date) return 0;
        // Parse DD/MM/YYYY for proper sorting
        const [d1, m1, y1] = a.date.split('/').map(Number);
        const [d2, m2, y2] = b.date.split('/').map(Number);
        const date1 = new Date(y1, m1 - 1, d1);
        const date2 = new Date(y2, m2 - 1, d2);
        return date2 - date1;
    });

    target.innerHTML = sortedHistory.map(item => {
        const statusClass = getStatusClass(item.status);
        const icon = getStatusIcon(item.status);
        
        return `
            <div class="history-item" style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 12px 15px;
                border-bottom: 1px solid #eee;
                background: ${item.date === new Date().toLocaleDateString('en-GB') ? '#f0fdf4' : 'transparent'};
            ">
                <div style="display:flex;align-items:center;gap:10px;">
                    <span style="font-size:16px;">${icon}</span>
                    <div>
                        <div style="font-weight:600;">${item.date || 'Unknown Date'}</div>
                        ${item.time ? `<small style="color:#666;">${item.time}</small>` : ''}
                    </div>
                </div>
                <span style="
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 600;
                    ${statusClass}
                ">${item.status || 'Unknown'}</span>
            </div>`;
    }).join('');
}
// 2. Separate Stats Update Function
function updateAttendanceStats(history, presentEl, absentEl) {
    if (!Array.isArray(history)) return;
    
    const todayStr = new Date().toLocaleDateString('en-GB'); // DD/MM/YYYY
    
    const presentToday = history.filter(item => {
        if (!item || !item.date) return false;
        return item.date === todayStr && !item.status?.includes('Absent');
    }).length;
    
    const totalStaff = 10; // Adjust based on your actual staff count
    
    if (presentEl) presentEl.innerText = presentToday;
    if (absentEl) absentEl.innerText = Math.max(0, totalStaff - presentToday);
}
// 9. Clock Function (Single Source of Truth)
function startAttendanceClock() {
    const updateClock = () => {
        const now = new Date();
        
        // Timer element (if exists)
        const timerEl = document.getElementById('att-timer');
        if (timerEl) timerEl.innerText = now.toLocaleTimeString('en-GB', { hour12: false });

        // Dashboard Day/Date
        const dayEl = document.getElementById('current-day-display');
        const dateEl = document.getElementById('current-date-display');
        
        if (dayEl) {
            dayEl.innerText = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(now);
        }
        if (dateEl) {
            dateEl.innerText = now.toLocaleDateString('en-GB');
        }
    };

    updateClock(); // Initial call
    return setInterval(updateClock, 1000);
}
async function updateDashboardAttendanceStats(history) {
    const presentEl = document.getElementById('stat-attendance-present');
    const absentEl = document.getElementById('stat-attendance-absent');
    if (!presentEl) return;

    const todayStr = new Date().toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
    
    // Aaj ki attendance filter karein
    const presentToday = history.filter(item => item.date === todayStr && !item.status.includes('Absent')).length;
    const totalStaff = 10; // Isko aap apne total staff count ke mutabiq badal sakte hain

    presentEl.innerText = presentToday;
    if (absentEl) absentEl.innerText = Math.max(0, totalStaff - presentToday);
}
function updateAttendanceUIStats(history) {
    const presentEl = document.getElementById('stat-orders-paid'); // Present ke liye ye use kar sakte hain ya nayi ID
    const absentEl = document.getElementById('stat-orders-unful'); 
    
    // Note: Aapne HTML mein attendance ke liye specific IDs nahi di thin, 
    // isliye hum 'Orders' wali cards ko as placeholder use kar rahe hain ya aap nayi IDs add karein.
    
    const today = new Date().toLocaleDateString('en-GB');
    const presentToday = history.filter(item => item.date === today && !item.status.includes('Absent')).length;
    
    // Agar aapne HTML mein IDs change ki hain to yahan update karein
    const pCount = document.getElementById('stat-attendance-present'); 
    if(pCount) pCount.innerText = presentToday;
}
// 8. Export Function
window.exportAttendanceToExcel = async () => {
    const userName = window.USER_NAME || document.querySelector('.user-name')?.innerText || "Admin";
    
    if (window.toggleLoader) window.toggleLoader(true);

    try {
        const res = await fetch(SYSTEM.BRIDGE, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
                auth_key: SYSTEM.AUTH,
                endpoint: '/get_history',
                data: { name: userName, export_full: true } 
            })
        });
        
        const data = await res.json();
        
        // Ensure data is array
        const exportData = Array.isArray(data) ? data : 
                          (Array.isArray(data?.data) ? data.data : []);
        
        if (exportData.length === 0) {
            alert("No data to export.");
            return;
        }

        let csv = "Date,Time,Status,Location\n";
        exportData.forEach(row => {
            csv += `"${row.date || ''}","${row.time || ''}","${row.status || ''}","${row.location || ''}"\n`;
        });

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Attendance_${userName}_${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        
    } catch (e) {
        alert("Export failed: " + e.message);
    } finally {
        if (window.toggleLoader) window.toggleLoader(false);
    }
};

window.adminAdjustAttendance = async () => {
    const name = document.getElementById('manual-staff-name')?.value;
    const date = document.getElementById('manual-date')?.value;
    const status = document.getElementById('manual-status')?.value;

    if (!name || !date || !status) {
        alert("Please fill all fields!");
        return;
    }

    // Validate date format (1-31)
    const dayNum = parseInt(date);
    if (isNaN(dayNum) || dayNum < 1 || dayNum > 31) {
        alert("Please enter a valid date (1-31)!");
        return;
    }

    if (window.toggleLoader) window.toggleLoader(true);

    try {
        const res = await fetch(SYSTEM.BRIDGE, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
                auth_key: SYSTEM.AUTH,
                endpoint: '/admin_adjust',
                data: { 
                    name, 
                    date: `${date}/${new Date().toLocaleDateString('en-GB').split('/').slice(1).join('/')}`, 
                    status 
                }
            })
        });

        const result = await res.json();
        showAttendanceNotification(result.status === "success", result.message);
        
        if (result.status === "success") {
            fetchAttendanceHistory(); // Refresh list
        }
    } catch (e) {
        showAttendanceNotification(false, "Update failed: " + e.message);
    } finally {
        if (window.toggleLoader) window.toggleLoader(false);
    }
};
// Fake Logs for UI (As placeholder)
function loadRecentLogs() {
    const target = document.getElementById('attendance-logs-target');
    // Isko aap Google Sheet se fetch karke bhi dikha sakte hain
    target.innerHTML = `<div class="log-entry"><b>ID: ${Math.floor(Math.random()*1000)}</b> checked in at ${new Date().toLocaleTimeString()}</div>` + target.innerHTML;
}
window.exportToExcel=modType=>{
  const data=UI_DATA[modType.toLowerCase()]||[];
  let csv="data:text/csv;charset=utf-8,";
  let rows=[];
  if(modType.toLowerCase()==='inventory'){
    rows.push(["Product","Vendor","SKU","Price","Stock"]);
    let sum=0;
    data.forEach(p=>p.variants.forEach(v=>{sum+=(v.inventory_quantity||0);rows.push([p.title,p.vendor,v.sku,v.price,v.inventory_quantity])}));
    rows.push(["","","","TOTAL UNITS",sum]);
  }else if(modType.toLowerCase()==='orders'){
    rows.push(["Order","Customer","Phone","Status","Amount"]);
    let sum=0;
    data.forEach(o=>{sum+=parseFloat(o.total_price);rows.push([o.name,o.customer?.first_name,o.customer?.phone,o.financial_status,o.total_price])});
    rows.push(["","","","TOTAL SALES",sum.toFixed(2)]);
  }
  rows.forEach(r=>csv+=r.join(",")+"\r\n");
  const link=document.createElement("a");
  link.setAttribute("href",encodeURI(csv));
  link.setAttribute("download",`${modType}_Report.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// Main scanner start function
window.startScanner = function(mode = 'inventory') {
    console.log("Starting scanner in mode:", mode);
    
    // Check if Quagga2 is loaded
    if (typeof Quagga === 'undefined') {
        alert("Scanner library loading... Please try again in 2 seconds.");
        // Auto-retry after 2 seconds
        setTimeout(() => startScanner(mode), 2000);
        return;
    }

    // Show modal
    const modal = document.getElementById('scanner-modal');
    if (!modal) {
        console.error("Scanner modal not found! Creating one...");
        createScannerModal();
        return startScanner(mode); // Retry after creating
    }
    
    modal.style.display = 'flex';
    scannerActive = true;

    // Initialize Quagga2 with mobile-optimized settings
    Quagga.init({
        inputStream: {
            name: "Live",
            type: "LiveStream",
            target: document.querySelector('#interactive'),
            constraints: {
                facingMode: "environment", // Back camera
                width: { min: 640, ideal: 1280, max: 1920 },
                height: { min: 480, ideal: 720, max: 1080 },
                aspectRatio: { min: 1, max: 2 }
            },
            area: {
                top: "25%",
                right: "10%",
                left: "10%",
                bottom: "25%"
            }
        },
        locator: {
            patchSize: "medium", // "small" | "medium" | "large" | "x-large"
            halfSample: true
        },
        numOfWorkers: navigator.hardwareConcurrency || 4,
        frequency: 10, // Scan 10 times per second
        decoder: {
            readers: [
                "code_128_reader",    // Most common for products
                "ean_reader",         // EAN-13
                "ean_8_reader",       // EAN-8
                "upc_reader",         // UPC-A
                "upc_e_reader",       // UPC-E
                "code_39_reader",     // Code 39
                "code_39_vin_reader", // Code 39 VIN
                "codabar_reader",     // Codabar
                "i2of5_reader",       // Interleaved 2 of 5
                "2of5_reader",        // Standard 2 of 5
                "code_93_reader"      // Code 93
            ],
            debug: {
                showCanvas: false,
                showPatches: false,
                showFoundPatches: false,
                showSkeleton: false,
                showLabels: false,
                showPatchLabels: false,
                showRemainingPatchLabels: false,
                boxFromPatches: {
                    showTransformed: false,
                    showTransformedBox: false,
                    showBB: false
                }
            }
        },
        locate: true // Try to locate barcode automatically
    }, function(err) {
        if (err) {
            console.error("Quagga Init Error:", err);
            alert("Camera error: " + err.message);
            window.stopScanner();
            return;
        }
        
        console.log("Quagga initialized successfully");
        Quagga.start();
        
        // Add visual feedback
        addScannerOverlay();
    });

    // Handle barcode detection
    Quagga.onDetected(function(result) {
        const code = result.codeResult.code;
        const format = result.codeResult.format;
        
        console.log("Detected:", code, "Format:", format);
        
        // Validate code (minimum 3 characters)
        if (!code || code.length < 3) return;
        
        // Debounce - prevent multiple scans of same code
        if (scanTimeout) clearTimeout(scanTimeout);
        
        scanTimeout = setTimeout(() => {
            handleScannedCode(code, mode);
        }, 300);
    });

    // Handle processing feedback (optional visual guide)
    Quagga.onProcessed(function(result) {
        const drawingCtx = Quagga.canvas.ctx.overlay;
        const drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                // Barcode found - visual feedback
                drawingCtx.font = "24px Arial";
                drawingCtx.fillStyle = "green";
                drawingCtx.fillText(result.codeResult.code, 10, 30);
            }
        }
    });
};
// Handle scanned code based on mode
function handleScannedCode(code, mode) {
    console.log("Handling scanned code:", code, "Mode:", mode);
    
    // Vibrate for feedback
    if (navigator.vibrate) navigator.vibrate(200);
    
    // Stop scanner
    window.stopScanner();
    
    if (mode === 'attendance') {
        // For attendance - fill input and submit
        const input = document.getElementById('attendance-employee-id');
        if (input) {
            input.value = code;
            window.handleAttendanceSubmit(code);
        } else {
            alert("Employee ID input not found");
        }
    } else {
        // For inventory - search product
        const searchInput = document.getElementById('inv-search');
        if (searchInput) {
            searchInput.value = code;
            // Trigger filter with animation
            searchInput.style.background = "#dcfce7";
            setTimeout(() => searchInput.style.background = "", 500);
            window.filterInventory();
            
            // Show success message
            showScanSuccess(code);
        } else {
            alert("Search input not found");
        }
    }
}

// Show scan success notification
function showScanSuccess(code) {
    let notif = document.getElementById('scan-notification');
    if (!notif) {
        notif = document.createElement('div');
        notif.id = 'scan-notification';
        notif.style.cssText = `
            position: fixed;
            top: 80px;
            right: 20px;
            background: #10b981;
            color: white;
            padding: 15px 25px;
            border-radius: 8px;
            font-weight: 600;
            z-index: 10000;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            transform: translateX(400px);
            transition: transform 0.3s ease;
        `;
        document.body.appendChild(notif);
    }
    
    notif.innerHTML = `✅ Barcode Found: <b>${code}</b>`;
    notif.style.transform = "translateX(0)";
    
    setTimeout(() => {
        notif.style.transform = "translateX(400px)";
    }, 3000);
}

// Add visual overlay to scanner
function addScannerOverlay() {
    const viewport = document.querySelector('#interactive');
    if (!viewport) return;
    
    // Remove old overlay if exists
    const oldOverlay = viewport.querySelector('.scanner-overlay');
    if (oldOverlay) oldOverlay.remove();
    
    const overlay = document.createElement('div');
    overlay.className = 'scanner-overlay';
    overlay.style.cssText = `
        position: absolute;
        top: 25%;
        left: 10%;
        right: 10%;
        bottom: 25%;
        border: 2px solid #10b981;
        border-radius: 12px;
        box-shadow: 0 0 0 9999px rgba(0,0,0,0.5);
        pointer-events: none;
        z-index: 10;
    `;
    
    // Add corner markers
    const corners = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
    corners.forEach(corner => {
        const marker = document.createElement('div');
        marker.style.cssText = `
            position: absolute;
            width: 20px;
            height: 20px;
            border-color: #10b981;
            border-style: solid;
            ${corner.includes('top') ? 'top: -2px; border-top-width: 4px;' : 'bottom: -2px; border-bottom-width: 4px;'}
            ${corner.includes('left') ? 'left: -2px; border-left-width: 4px;' : 'right: -2px; border-right-width: 4px;'}
        `;
        overlay.appendChild(marker);
    });
    
    // Add instruction text
    const text = document.createElement('div');
    text.innerText = "Align barcode within frame";
    text.style.cssText = `
        position: absolute;
        bottom: -50px;
        left: 50%;
        transform: translateX(-50%);
        color: white;
        font-size: 14px;
        white-space: nowrap;
    `;
    overlay.appendChild(text);
    
    viewport.appendChild(overlay);
}

// Stop scanner
window.stopScanner = function() {
    console.log("Stopping scanner...");
    scannerActive = false;
    
    if (typeof Quagga !== 'undefined') {
        Quagga.stop();
        Quagga.offDetected();
        Quagga.offProcessed();
    }
    
    const modal = document.getElementById('scanner-modal');
    if (modal) modal.style.display = 'none';
    
    // Remove overlay
    const overlay = document.querySelector('.scanner-overlay');
    if (overlay) overlay.remove();
    
    if (scanTimeout) {
        clearTimeout(scanTimeout);
        scanTimeout = null;
    }
};

// Create scanner modal if not exists
function createScannerModal() {
    const modal = document.createElement('div');
    modal.id = 'scanner-modal';
    modal.className = 'modal-overlay';
    modal.style.cssText = `
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.9);
        z-index: 9999;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `;
    
    modal.innerHTML = `
        <div class="scanner-card" style="
            background: #1f2937;
            padding: 20px;
            border-radius: 16px;
            width: 90%;
            max-width: 500px;
            position: relative;
        ">
            <div style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 15px;
            ">
                <h3 style="margin: 0; color: white;">📷 Scan Barcode</h3>
                <button onclick="window.stopScanner()" style="
                    background: #ef4444;
                    color: white;
                    border: none;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    cursor: pointer;
                    font-size: 18px;
                ">×</button>
            </div>
            <div id="interactive" style="
                height: 300px;
                background: black;
                border-radius: 12px;
                overflow: hidden;
                position: relative;
            "></div>
            <div style="
                margin-top: 15px;
                display: flex;
                gap: 10px;
                justify-content: center;
            ">
                <button onclick="window.toggleFlashlight()" style="
                    background: #3b82f6;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 8px;
                    cursor: pointer;
                ">🔦 Flashlight</button>
                <button onclick="window.switchCamera()" style="
                    background: #6b7280;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 8px;
                    cursor: pointer;
                ">🔄 Switch Camera</button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
}
// Toggle flashlight (if supported)
window.toggleFlashlight = async function() {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" }
        });
        const track = stream.getVideoTracks()[0];
        
        // Check if torch is supported
        const capabilities = track.getCapabilities();
        if (capabilities.torch) {
            const settings = track.getSettings();
            await track.applyConstraints({
                advanced: [{ torch: !settings.torch }]
            });
        } else {
            alert("Flashlight not supported on this device");
        }
    } catch (err) {
        console.error("Flashlight error:", err);
        alert("Cannot access flashlight");
    }
};

// Switch camera (front/back)
let currentCamera = "environment";
window.switchCamera = function() {
    window.stopScanner();
    currentCamera = currentCamera === "environment" ? "user" : "environment";
    setTimeout(() => window.startScanner(), 500);
};

// Initialize scanner when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Pre-load Quagga2 for faster response
    if (typeof Quagga !== 'undefined') {
        console.log("Quagga2 pre-loaded");
    }
});
// 12. MISC HELPERS
window.toggleLoader=show=>{
  const l=document.getElementById('global-loader');
  if(l)l.style.display=show?'flex':'none';
};
window.handleLogout=()=>confirm("Logout?")?window.location.href="/account/logout":null;

// 13. AUTO-BOOT
window.onload=bootSystem;